import type { EquipmentTypeCatalogDto } from '@/api/generator';
import { SelectItemType } from '@/components/forms/types.ts';
import { InjectionKey } from 'vue';
import { NO_BRAND } from './utils';

export interface QaEquipmentAddFilterObject {
  subCategory?: EquipmentTypeCatalogDto['subCategory'][];
  brand1?: (EquipmentTypeCatalogDto['brand1'] | typeof NO_BRAND)[];
  search?: string;
}

export type QaEquipmentAddFilterAndSortingProps = {
  sortByItems: SelectItemType<string>[];
  items: EquipmentTypeCatalogDto[] | undefined;
};

type ReloadEquipmentFunction = () => void;
export const reloadEquipmentKey: InjectionKey<ReloadEquipmentFunction> = Symbol();

type SaveFunction = () => Promise<boolean>;
type RegisterSaveFunction = (save: SaveFunction) => () => void;
export const zeroMeasurementParametersSaveKey: InjectionKey<RegisterSaveFunction> = Symbol();
